export const SEO_CONFIG = {
  siteUrl: 'https://ludoka.soka.club',
  siteName: 'LUDOKA',
  themeColor: '#1a472a',
  defaultImage: '/pwa-512x512.png',
  supportedLanguages: ['fr', 'en', 'mg'] as const,
  defaultLanguage: 'fr'
} as const;
